import { connect } from 'react-redux';
import PresentationComponent from 'src/ui/features/Login/presentational';
import { login, loginSso, returnToLogin, gotoPage } from 'src/ui/features/Login/state/loginActions';
import { logoutSession } from 'src/ui/features/Login/state/loginActions';

const mapStateToProps = state => {
  const { error, loginStatus, numberAttempts, email, userSuccess, profileKey, loginPage, isAuthenticated, isRoleSelect } = state.login;

  return {
    error,
    loginStatus,
    numberAttempts,
    userSuccess,
    profileKey,
    loginPage,
    email,
    isAuthenticated,
    isRoleSelect,
  };
};

const mapDispatchToProps = {
  login,
  loginSso,
  returnToLogin,
  gotoPage,
  logoutSession,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { loginPage } = stateProps;
  const { login, ...otherDispatchers } = dispatchProps;
  let onClickAction = null;
  switch (loginPage) {
    default:
      onClickAction = login;
  }
  return {
    ...stateProps,
    ...otherDispatchers,
    onClick: onClickAction,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PresentationComponent);
